
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeatureBlocks from './components/FeatureBlocks';
import ProofSection from './components/ProofSection';
import { useSEO, useSchema } from '../../utils/seo';

export default function Home() {
  useSEO({
    title: 'EarnProof - Echte Apps, Echte Einnahmen | Geprüfte Earning-Tools',
    description: 'Entdecke geprüfte Apps, Games und Crypto-Tools mit echten Auszahlungsbeweisen. Keine Fake-Versprechungen, nur ehrliche Reviews und transparente Einnahmen.',
    keywords: 'earning apps, geld verdienen online, crypto tools, passive income, app reviews, auszahlungsbeweise, mistplay, freecash, scrambly',
    canonical: 'https://example.com/',
  });

  useSchema({
    type: 'WebSite',
    data: {
      name: 'EarnProof',
      url: 'https://example.com',
      description: 'Geprüfte Earning-Apps mit echten Auszahlungsbeweisen und ehrlichen Reviews',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://example.com/reviews?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
  });

  useSchema({
    type: 'Organization',
    data: {
      name: 'EarnProof',
      url: 'https://example.com',
      logo: 'https://example.com/logo.png',
      description: 'Ehrliche Reviews von Earning-Apps mit echten Auszahlungsbeweisen',
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'hello@earnproof.org',
        contactType: 'Customer Service',
        availableLanguage: 'de',
      },
    },
  });

  return (
    <div className="min-h-screen bg-gray-900">
      <Header />
      <main>
        <HeroSection />
        <div id="apps-section">
          <FeatureBlocks />
        </div>
        <ProofSection />
      </main>
      <Footer />
    </div>
  );
}
